import { DirectionType } from 'src/components/direction';
import { NetworkPointSuggestion } from 'src/pages/reporting/my-transactions/network-point-suggestions-input';
import { TsoSuggestion } from 'src/pages/reporting/my-transactions/tso-suggestions-input';
import {
  MixedProductType,
  SortDirection,
  TransactionsSortBy,
  TransactionStatus,
  TransactionType,
} from 'src/types/capacity-management';
import * as pp from 'src/utils/page-params';

export function usePageParams() {
  return pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(10))
      .add(pp.param('createdAtStart').filter({ label: 'Time of Creation' }))
      .add(pp.param('createdAtEnd').filter({ label: 'Time of Creation' }))
      .add(
        pp
          .list('tsoId')
          .deserialize<TsoSuggestion>(JSON.parse)
          .serialize(JSON.stringify)
          .filter({ label: 'TSO' })
      )
      .add(
        pp
          .list('networkPointId')
          .deserialize<NetworkPointSuggestion>(JSON.parse)
          .serialize(JSON.stringify)
          .filter({ label: 'Network Point' })
      )
      .add(
        pp
          .list('direction')
          .cast<DirectionType>()
          .filter({ label: 'Direction' })
      )
      .add(pp.list('marketAreaId').filter({ label: 'Market Area' }))
      .add(pp.list('capacityCategoryId').filter({ label: 'Category' }))
      .add(
        pp
          .list('productType')
          .cast<MixedProductType>()
          .filter({ label: 'Product' })
      )
      .add(
        pp.param('runtimeIntersectionFilterStart').filter({ label: 'Runtime' })
      )
      .add(
        pp.param('runtimeIntersectionFilterEnd').filter({ label: 'Runtime' })
      )
      .add(
        pp
          .list('transactionType')
          .cast<TransactionType>()
          .filter({ label: 'Transaction Type' })
      )
      .add(
        pp
          .param('transactionTypeSpecificId')
          .filter({ label: 'Transaction Type Specific Id' })
      )
      .add(
        pp.list('status').cast<TransactionStatus>().filter({ label: 'Status' })
      )
      .add(
        pp
          .optionalNumber('regulatedTariffMin')
          .filter({ label: 'Regulated Tariff' })
      )
      .add(
        pp
          .optionalNumber('regulatedTariffMax')
          .filter({ label: 'Regulated Tariff' })
      )
      .add(
        pp
          .boolean('onlyWithSurcharge')
          .default(false)
          .filter({ label: 'Only with Surcharge' })
      )
      .add(pp.optionalNumber('surchargeMin').filter({ label: 'Surcharge' }))
      .add(pp.optionalNumber('surchargeMax').filter({ label: 'Surcharge' }))
      .add(pp.optionalNumber('amountMin').filter({ label: 'Amount' }))
      .add(pp.optionalNumber('amountMax').filter({ label: 'Amount' }))
      .add(pp.param('sortBy').default<TransactionsSortBy>('CREATED_AT'))
      .add(pp.param('sortDirection').default<SortDirection>('desc'))
  );
}

export type PageParams = ReturnType<typeof usePageParams>;

export type PageParamsValue = PageParams['value'];
